import { FC } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons"

import { useAppDispatch } from "../../app/hooks";
import { useMessages2 } from "../../hooks/useLanguage";
import { closePopup } from "../../app/popup-slice";
import { ButtonBar } from "../buttons";

import styles from './info-model-dialog.module.css'
import { useModelInfoData } from '../../app/configurator-hooks';

export function InfoModelDialog({ modelName } : {
    modelName: string
}) {

    const dispatch = useAppDispatch()
    const { messages } = useMessages2();
    const { data: modelInfo, isLoading } = useModelInfoData();

    const handleClose = () => {
        dispatch(closePopup())
    }

    return (
        <div className={styles.dialogContainer}>
        
            <div className={styles.topContent}>
                <div className={styles.title}>
                    <h2>{messages?.overlay_model_prefix} {modelName}</h2>
                </div>
                
                <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.closeButton}
                    onClick={handleClose}
                />
            </div>
                
            <div className={styles.infoContainer} >
                <ul className={styles.textInfo}>
                    {
                        isLoading ? <li>...</li> : modelInfo?.map(info => (
                            <li key={info.bulletid}>{info.bullettext}</li>
                        ))
                    }
                </ul>
                <div className={styles.directButton}>             
                    <ButtonBar>
                        <button onClick={handleClose} className={styles.button}>{messages?.page_close_button}</button>
                    </ButtonBar>
                </div>
            </div> 

        </div>
    )
}